export default "<div class=\"scroll-btn-wrap\" (click)=\"toggle()\" *ngIf=\"showBtn\">\n  <span class=\"iron\"></span>\n</div>\n";